// extracted by mini-css-extract-plugin
module.exports = {"container":"fE","image":"fF","title":"fG","desc":"fH"};